import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject;
import styled from 'styled-components';
import { Icon } from '@magalu/stereo-ui-icons';
export var SharedActionsIcon = styled(Icon)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  fill: ", " !important;\n"])), function (_ref) {
  var color = _ref.color;
  return color;
});